import { F } from './fancybox-BwXPTMi7.js';

class ProductMedia extends HTMLElement {
  #swiperInstance = null;
  #mediaItems = [...this.querySelectorAll('.product-media-item')];

  async connectedCallback() {
    await this.#initSwiper();
    this.initFancybox();

    // Re-initialize the swiper instance on the viewport width change. Needed to switch between Swiper and Grid
    const matchMedia = window.matchMedia('(min-width: 768px)');
    matchMedia.addEventListener('change', () => this.#initSwiper());
  }

  async #initSwiper() {
    if (this.#mediaItems.length <= 1) return;
    if (window.matchMedia('(min-width: 768px)').matches) return this.#swiperInstance?.destroy();

    try {
      const { Swiper } = await import('./swiper-DSEIACnL.js');
      const { Navigation, Pagination } = await import('./index-CrPdh8ZS.js');

      this.#swiperInstance = new Swiper('.swiper--media', {
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }

  initFancybox() {
    F.bind('[data-fancybox]', {
      Carousel: {
        Panzoom: {
          touch: (panzoom, event) => event?.target.nodeName !== 'MODEL-VIEWER',
        },
      },
    });
  }
}

customElements.define('product-media', ProductMedia);
